module.exports = __webpack_public_path__ + "static/media/comment-alt-lines.86cdc59b.svg";